import React, { useContext, useEffect } from "react";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import { Button, Container, Typography, Box, Autocomplete, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Stepper, StepLabel, Step } from "@mui/material";
import Global from "../util/Global";
import { GlobalData } from "../util/GlobalData";
import axios from "axios";
import { AlertContext } from "../util/Alerter";
import AvatarUploader from "../components/AvatarUploader";
import { useNavigate } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import BadgeIcon from '@mui/icons-material/Badge';
import ContactsIcon from '@mui/icons-material/Contacts';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import NumbersIcon from '@mui/icons-material/Numbers';
import BusinessIcon from '@mui/icons-material/Business';
import LockIcon from '@mui/icons-material/Lock';
import Mapss from "./Mapss";
import FileUploader from "../components/FileUploader";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import WorkIcon from '@mui/icons-material/Work';
import MaleIcon from '@mui/icons-material/Male';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { DeliveryCountryContext } from "../components/Utils";


const SignUp2 = () => {
  // step == 1 (user form), step == 2 (business form)
  const [signupStep, setsignupStep] = useState(0)
  const [isBusinessAccount, setisBusinessAccount] = useState(false)
  const { t } = useTranslation()
  const [isLoading, setisLoading] = useState(false)
  const { countries } = useContext(DeliveryCountryContext)
  const { showAlert } = useContext(AlertContext)
  const navigate = useNavigate()

  // user info
  const [firstName, setfirstName] = useState("")
  const [lasttName, setlasttName] = useState("")
  const [phone, setphone] = useState("")
  const [civility, setcivility] = useState("")
  const [address, setaddress] = useState("")
  const [email, setemail] = useState("")
  const [password, setpassword] = useState("")
  const [confirmPassword, setconfirmPassword] = useState("")
  const [country, setCountry] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [city, setCity] = useState("")

  // user info if business
  const [service, setService] = useState("")
  const [fonction, setfonction] = useState("")


  // business info
  const [entrepriseName, setentrepriseName] = useState("")
  const [entrepriseEmail, setentrepriseEmail] = useState("")
  const [entrepriseAddress, setentrepriseAddress] = useState("")
  const [entrepriseCountry, setentrepriseCountry] = useState("")
  const [entrepriseCity, setentrepriseCity] = useState("")
  const [entreprisePostalCode, setentreprisePostalCode] = useState("")
  const [entreprisePhone, setentreprisePhone] = useState("")
  const [entrepriseActivity, setentrepriseActivity] = useState("")
  const [tvaEntreprise, settvaEntreprise] = useState("");
  const [immEntreprise, setimmEntreprise] = useState("");
  const [dateEntreprise, setdateEntreprise] = useState("");
  const [immatriculationEntreprise, setimmatriculationEntreprise] = useState("");
  const [certificatEntreprise, setcertificatEntreprise] = useState("");
  const [logoEntreprise, setlogoEntreprise] = useState("");
  const [regionEntreprise, setregionEntreprise] = useState("");
  const [latEntreprise, setlatEntreprise] = useState();
  const [lonEntreprise, setlonEntreprise] = useState();




  // these are keys used for translations
  const businessAccountSteps = [
    "accountType",
    "businessInfo",
    "accountInfo"
  ]
  const normalAccountSteps = [
    "accountType",
    "accountInfo"
  ]


  const [errors, setErrors] = useState({
    mail: false,
    nom: false,
    prenom: false,
    phone: false,
    civilite: false,
    service: false,
    fonction: false,
    adresse: false,
    ville: false,
    pays: false,
    code: false,
    password: false,
    confirmPassword: false,
    entrepriseName: false,
    entrepriseEmail: false,
    entrepriseAddress: false,
    entrepriseCountry: false,
    entrepriseCity: false,
    entreprisePostalCode: false,
    entreprisePhone: false,
    entrepriseActivity: false,
    tvaEntreprise: false,
    immEntreprise: false,
    dateEntreprise: false,
    immatriculationEntreprise: false,
    certificatEntreprise: false,
    logoEntreprise: false,
    latEntreprise: false,
    lonEntreprise: false,
  });




  const INSCRIPTION_URL = Global.backend + "/index.php/user/register";


  useEffect(() => {

  }, []);



  function onPrevious() {
    if (signupStep == 2) {
      if (isBusinessAccount) {
        setsignupStep(1)
      } else {
        setsignupStep(0)
      }
    } else {
      setsignupStep(0)
    }
  }



  const checkInputs = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



    const errors = {
      mail: signupStep == 2 && !emailRegex.test(email),
      nom: signupStep == 2 && lasttName.length < 4,
      prenom: signupStep == 2 && firstName.length < 4,
      phone: signupStep == 2 && false,
      civilite: signupStep == 2 && false,
      service: isBusinessAccount && signupStep == 2 && !GlobalData.user.services.includes(service),
      fonction: isBusinessAccount && signupStep == 2 && !GlobalData.user.functions.includes(fonction),
      adresse: signupStep == 2 && false,
      ville: signupStep == 2 && false,
      pays: signupStep == 2 && !country,
      code: signupStep == 2 && false,
      password: signupStep == 2 && password.length < 8,
      confirmPassword: signupStep == 2 && confirmPassword != password,
      entrepriseName: signupStep == 1 && entrepriseName.length < 4,
      entrepriseEmail: signupStep == 1 && !emailRegex.test(entrepriseEmail),
      entrepriseAddress: signupStep == 1 && entrepriseAddress.length < 4,
      entrepriseCountry: signupStep == 1 && !entrepriseCountry,
      entrepriseCity: signupStep == 1 && !entrepriseCity,
      entreprisePostalCode: signupStep == 1 && entreprisePostalCode.length < 4,
      entreprisePhone: signupStep == 1 && entreprisePhone.length < 8,
      entrepriseActivity: signupStep == 1 && !GlobalData.user.activities.includes(entrepriseActivity),
      tvaEntreprise: signupStep == 1 && !tvaEntreprise,
      immEntreprise: signupStep == 1 && !immEntreprise,
      dateEntreprise: signupStep == 1 && !dateEntreprise,
      immatriculationEntreprise: signupStep == 1 && !immatriculationEntreprise,
      certificatEntreprise: signupStep == 1 && !certificatEntreprise,
      logoEntreprise: signupStep == 1 && !logoEntreprise,
      latEntreprise: signupStep == 1 && !latEntreprise,
      lonEntreprise: signupStep == 1 && !lonEntreprise,
    };

    setErrors(errors)



    const hasErrors = Object.values(errors).some(error => error)

    if (hasErrors) {
      let errorMessage = ""



      if (errors.nom || errors.prenom || errors.civilite || errors.phone | errors.pays || errors.adresse || errors.city || errors.code) {
        errorMessage = t("user.verifypersonalInformation")
      } else if (errors.fonction || errors.service) {
        errorMessage = t("user.verifyprofessionalInformation")
      } else if (errors.password || errors.confirmPassword) {
        errorMessage = t("user.verifyLoginDetails")
      }



      if (errors.entrepriseEmail || errors.entreprisePhone) {
        errorMessage = t("user.verifycompanyContactDetails")
      } else if (errors.entrepriseName || errors.entrepriseCountry || errors.entrepriseAddress || errors.entrepriseCity || errors.entreprisePostalCode) {
        errorMessage = t("user.verifycompanyGeneralInformation")
      } else if (errors.entrepriseActivity || errors.tvaEntreprise || errors.immEntreprise || errors.dateEntreprise) {
        errorMessage = t("user.verifycompanyprofessionalInformation")
      }
      else if (errors.immatriculationEntreprise || errors.certificatEntreprise) {
        errorMessage = t("user.verifylegalInformation")
      } else if (errors.logoEntreprise || errors.latEntreprise || errors.lonEntreprise) {
        errorMessage = t("user.verifylogoAndLocation")
      }





      showAlert("error", errorMessage)
    }


    return !hasErrors
  }


  function onSubmit() {
    if (signupStep < 2) {
      if (signupStep == 0) {
        if (isBusinessAccount) {
          setsignupStep(1)
        } else {
          setsignupStep(2)
        }
      } else {
        if (!checkInputs()) {
          return
        }
        setsignupStep(2)
      }


      return
    }


    if (!checkInputs()) {
      return
    }


    // signup request
    setisLoading(true)



    const formData = new FormData()


    formData.append("nom", lasttName);
    formData.append("prenom", firstName);
    formData.append("telephone", Number(phone));
    formData.append("civilite", civility);
    formData.append("adresse", address);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("pays", country);
    formData.append("ville", city);
    formData.append("code_postal", postalCode);


    formData.append("compte", isBusinessAccount ? 1 : 0);

    if (isBusinessAccount) {
      formData.append("service", service);
      formData.append("fonction", fonction);
      formData.append("nomentreprise", entrepriseName);
      formData.append("adresseEntreprise", entrepriseAddress);
      formData.append("paysEntreprise", entrepriseCountry);
      formData.append("villeEntreprise", entrepriseCity);
      formData.append("code_postalEntreprise", entreprisePostalCode);
      formData.append("region", "");
      formData.append("activite", entrepriseActivity);
      formData.append("emailEntreprise", entrepriseEmail);
      formData.append("fax", entreprisePhone);
      formData.append("tva", tvaEntreprise);
      formData.append("imm", immEntreprise);
      formData.append("date", dateEntreprise);
      formData.append("lat", latEntreprise);
      formData.append("lng", lonEntreprise);


      if (logoEntreprise instanceof File) {
        formData.append("logo", logoEntreprise);
      } else {
        formData.append("logo", "");
      }


      
      if (immatriculationEntreprise instanceof File) {
        formData.append("immatriculefile", immatriculationEntreprise);
      } else {
        formData.append("immatriculefile", "");
      }

      if (certificatEntreprise instanceof File) {
        formData.append("certificat", certificatEntreprise);
      } else {
        formData.append("certificat", "");
      }
    }



    axios.post(INSCRIPTION_URL, formData)
      .then((response) => {
        if (response.data.message.includes("email")) {
          showAlert("error", t("request.emailExist"))
        } else {
          showAlert("success", t("request.successSignup"))
          navigate("/login")
        }
      }).catch(() => {
        showAlert("error", t("request.errorSignup"))
      })
      .finally(() => {
        setisLoading(false);

      });
  }


  const CustomStepLabel = ({ children }) => {
    return (
      <StepLabel sx={{
        '& .MuiStepLabel-label.Mui-active': { fontWeight: "bold" },
        '& .MuiStepIcon-text': { fontSize: 20 },
        '& .MuiSvgIcon-root': { fontSize: 35 },
        '& .MuiSvgIcon-root.Mui-active': { color: "#b07b39" },
        '& .MuiSvgIcon-root.Mui-completed': { color: "#ca8d42" }
      }}>
        {children}
      </StepLabel>
    )
  }

  return (
    <Container component="main" maxWidth="md" sx={{ display: "flex", minHeight: "100vh", pt: 20, pb: 10, alignItems: "center", justifyContent: "center" }}>
      <div className="card shadow-lg w-100">
        <div className="card-body">
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <img
              src={require("../assets/FrontOffice/images/techoney.png")}
              alt="logo"
              style={{ width: 90 }}

            />
          </Box>
          <Typography variant="h5" component="h1" align="center" gutterBottom>
            {t("login5.1")}
          </Typography>



          <Box sx={{ width: '100%' }}>
            <Stepper activeStep={signupStep == 0 ? 0 : (signupStep == 1 ? 1 : (isBusinessAccount && signupStep == 2 ? 2 : 1))} alternativeLabel>
              {isBusinessAccount ? businessAccountSteps.map((step, index) => {
                return (
                  <Step key={index}>
                    <CustomStepLabel>{t("signupSteps." + step)}</CustomStepLabel>
                  </Step>
                )
              }) :
                normalAccountSteps.map((step, index) => {
                  return (
                    <Step key={index}>
                      <CustomStepLabel>{t("signupSteps." + step)}</CustomStepLabel>
                    </Step>
                  )
                })}
            </Stepper>
          </Box>


          <Box component="form" noValidate sx={{ mt: 3, mb: 3 }}>
            {signupStep == 0 ?
              <div className="row">
                <div className="col-12">
                  <FormControl fullWidth>
                    <InputLabel>{t("user.accountType")}</InputLabel>
                    <Select
                      IconComponent={ManageAccountsIcon}
                      value={isBusinessAccount ? 1 : 0}
                      label={t("user.function")}
                      onChange={(e) => {
                        setisBusinessAccount(e.target.value == 1)
                      }}
                    >
                      <MenuItem value={0}>{t("buyer")}</MenuItem>
                      <MenuItem value={1}>{t("seller")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              : signupStep == 1 ?
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12">


                      <div className="card shadow-lg">
                        <div className="card-body">
                          <div
                            id="addproduct-nav-pills-wizard"
                            className="twitter-bs-wizard"
                          >
                            <div className=" twitter-bs-wizard-tab-content">
                              <div className="tab-pane" id="basic-info">
                                <h4 className="card-title">{t("user.companyContactDetails")}</h4>
                                <p className="card-title-desc"></p>


                                <div className="row mb-3">
                                  <div className="col">
                                    <TextField error={errors.entrepriseEmail} value={entrepriseEmail} fullWidth variant="outlined" type="text" label={t("user.mail")} onChange={(e) => setentrepriseEmail(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <EmailIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>
                                  <div className="col">
                                    <TextField error={errors.entreprisePhone} value={entreprisePhone} fullWidth variant="outlined" type="text" label={t("user.fax")} onChange={(e) => setentreprisePhone(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <PhoneIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>
                                </div>
                              </div>

                            </div>



                            <hr />



                            <div className="tab-pane" id="basic-info">
                              <h4 className="card-title">{t("user.companyGeneralInformation")}</h4>
                              <div className="row mb-3">
                                <div className="col">
                                  <TextField error={errors.entrepriseName} value={entrepriseName} fullWidth variant="outlined" type="text" label={t("user.companyName")} onChange={(e) => setentrepriseName(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <BusinessIcon />
                                        </InputAdornment>
                                      )
                                    }} />
                                </div>
                                <div className="col">
                                  <Autocomplete
                                    disablePortal
                                    fullWidth
                                    options={countries.map((val) => ({
                                      label: val.name,
                                      value: val.name
                                    }))}
                                    value={entrepriseCountry}
                                    onChange={(event, newValue) => {
                                      setentrepriseCountry(newValue?.value);
                                    }}
                                    renderInput={(params) => (
                                      <TextField error={errors.entrepriseCountry} {...params} label={t("user.pays")} variant="outlined" />
                                    )}
                                    disableClearable={true}
                                  />
                                </div>
                              </div>

                              <div className="row mb-3">
                                <div className="col">
                                  <TextField error={errors.entrepriseAddress} value={entrepriseAddress} fullWidth variant="outlined" type="text" label={t("user.address")} onChange={(e) => setentrepriseAddress(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <ContactsIcon />
                                        </InputAdornment>
                                      )
                                    }} />
                                </div>
                                <div className="col">
                                  <TextField error={errors.entrepriseCity} value={entrepriseCity} fullWidth variant="outlined" type="text" label={t("user.city")} onChange={(e) => setentrepriseCity(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <LocationCityIcon />
                                        </InputAdornment>
                                      )
                                    }} />
                                </div>
                                <div className="col">
                                  <TextField error={errors.entreprisePostalCode} value={entreprisePostalCode} fullWidth variant="outlined" type="text" label={t("user.postalCode")} onChange={(e) => setentreprisePostalCode(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <NumbersIcon />
                                        </InputAdornment>
                                      )
                                    }} />
                                </div>
                              </div>
                            </div>


                            <hr />



                            <div className="tab-pane" id="professional-info">
                              <h4 className="card-title">{t("user.companyprofessionalInformation")}</h4>
                              <div className="row mb-3">
                                <div className="col-6">
                                  <FormControl error={errors.entrepriseActivity} fullWidth>
                                    <InputLabel>{t("user.activity")}</InputLabel>
                                    <Select
                                      IconComponent={WorkIcon}
                                      value={entrepriseActivity}
                                      label={t("user.activity")}
                                      onChange={(e) => setentrepriseActivity(e.target.value)}
                                    >
                                      {GlobalData.user.activities.map((val, index) => {
                                        return (
                                          <MenuItem key={index} value={val}>{t("user.activities." + val)}</MenuItem>
                                        )
                                      })}
                                    </Select>
                                  </FormControl>
                                </div>
                                <div className="col-6">
                                  <TextField error={errors.tvaEntreprise} value={tvaEntreprise} fullWidth variant="outlined" type="text" label={t("user.tva")} onChange={(e) => settvaEntreprise(e.target.value)} />
                                </div>
                              </div>

                              <div className="row mb-3">
                                <div className="col-6">
                                  <TextField error={errors.immEntreprise} value={immEntreprise} fullWidth variant="outlined" type="text" label={t("user.imm")} onChange={(e) => setimmEntreprise(e.target.value)} />
                                </div>
                                <div className="col-6">
                                  <TextField error={errors.dateEntreprise} value={dateEntreprise} fullWidth variant="outlined" type="number" label={t("user.dateCreation")} onChange={(e) => setdateEntreprise(e.target.value)} />
                                </div>
                              </div>
                            </div>

                            <hr />

                            <div className="tab-pane" id="files">
                              <h4 className="card-title">{t("user.legalInformation")}</h4>
                              <div className="row mb-3">
                                <div className="col-6">
                                  <FileUploader label={t("uploadHoneyTestReport")} error={errors.immatriculationEntreprise} attachedFile={immatriculationEntreprise} onChange={setimmatriculationEntreprise} />
                                </div>
                                <div className="col-6">
                                  <FileUploader label={t("uploadCompanyRegistrationCertificate")} error={errors.certificatEntreprise} attachedFile={certificatEntreprise} onChange={setcertificatEntreprise} />
                                </div>
  
                              </div>
                            </div>



                            <hr />


                            <div className="tab-pane" id="location">
                              <h4 className="card-title">{t("user.logoAndLocation")}</h4>


                              <div className="mb-3">
                                <AvatarUploader id={"logoEntreprise"} image={logoEntreprise} setImage={setlogoEntreprise} />
                              </div>


                              <div className="row mb-3">

                                <div className="col-md-6" style={{ marginLeft: "auto", marginRight: "auto" }}>
                                  <Mapss lat={latEntreprise} lon={lonEntreprise} canEdit={true} setPosition={(e) => {
                                    setlatEntreprise(e[0])
                                    setlonEntreprise(e[1])
                                  }} />
                                </div>

                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                :

                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12">


                      <div className="card shadow-lg">
                        <div className="card-body">
                          <div
                            id="addproduct-nav-pills-wizard"
                            className="twitter-bs-wizard"
                          >
                            <div className=" twitter-bs-wizard-tab-content">



                              <div className="tab-pane" id="basic-info">
                                <h4 className="card-title">{t("user.personalInformation")}</h4>
                                <p className="card-title-desc"></p>


                                <div className="row mb-3">
                                  <div className="col-3">
                                    <TextField value={firstName} error={errors.prenom} fullWidth variant="outlined" type="text" label={t("user.firstName")} onChange={(e) => setfirstName(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <BadgeIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>
                                  <div className="col-3">
                                    <TextField value={lasttName} error={errors.nom} fullWidth variant="outlined" type="text" label={t("user.lastName")} onChange={(e) => setlasttName(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <BadgeIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>
                                  <div className="col-3">
                                    <FormControl error={errors.civilite} fullWidth>
                                      <InputLabel>{t("user.civility")}</InputLabel>
                                      <Select
                                        IconComponent={MaleIcon}
                                        value={civility}
                                        label={t("user.civility")}
                                        onChange={(e) => {
                                          setcivility(e.target.value)
                                        }
                                        }
                                      >
                                        {GlobalData.user.civilities.map((val, index) => {
                                          return (
                                            <MenuItem key={index} value={val}>{t("user.civilities." + val)}</MenuItem>
                                          )
                                        })}
                                      </Select>
                                    </FormControl>
                                  </div>
                                  <div className="col-3">
                                    <TextField value={phone} error={errors.phone} fullWidth variant="outlined" type="text" label={t("user.phone")} onChange={(e) => setphone(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <PhoneIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>

                                </div>




                                <div className="row mb-3">
                                  <div className="col">
                                    <Autocomplete
                                      disablePortal
                                      fullWidth
                                      options={countries.map((val) => ({
                                        label: val.name,
                                        value: val.name
                                      }))}
                                      value={country}
                                      onChange={(event, newValue) => {
                                        setCountry(newValue?.value);
                                      }}
                                      renderInput={(params) => (
                                        <TextField error={errors.pays} {...params} label={t("user.pays")} variant="outlined" />
                                      )}
                                      disableClearable={true}
                                    />
                                  </div>

                                  <div className="col">
                                    <TextField value={address} error={errors.adresse} fullWidth variant="outlined" type="text" label={t("user.address")} onChange={(e) => setaddress(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <ContactsIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>

                                </div>
                              </div>



                              <div className="row mb-3">

                                <div className="col">
                                  <TextField value={city} error={errors.ville} fullWidth variant="outlined" type="text" label={t("user.city")} onChange={(e) => setCity(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <LocationCityIcon />
                                        </InputAdornment>
                                      )
                                    }} />
                                </div>
                                <div className="col">
                                  <TextField value={postalCode} error={errors.code} fullWidth variant="outlined" type="text" label={t("user.postalCode")} onChange={(e) => setPostalCode(e.target.value)}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <NumbersIcon />
                                        </InputAdornment>
                                      )
                                    }} />
                                </div>
                              </div>



                              <hr />


                              {isBusinessAccount &&
                                <div className="tab-pane" id="basic-info">
                                  <h4 className="card-title">{t("user.professionalInformation")}</h4>
                                  <p className="card-title-desc"></p>


                                  <div className="row mb-3">
                                    <div className="col-6">
                                      <FormControl error={errors.fonction} fullWidth>
                                        <InputLabel>{t("user.function")}</InputLabel>
                                        <Select
                                          IconComponent={WorkOutlineIcon}
                                          value={fonction}
                                          label={t("user.function")}
                                          onChange={(e) => setfonction(e.target.value)}
                                        >
                                          {GlobalData.user.functions.map((val, index) => {
                                            return (
                                              <MenuItem key={index} value={val}>{t("user.functions." + val)}</MenuItem>
                                            )
                                          })}
                                        </Select>
                                      </FormControl>
                                    </div>
                                    <div className="col-6">
                                      <FormControl error={errors.service} fullWidth>
                                        <InputLabel>{t("user.service")}</InputLabel>
                                        <Select
                                          IconComponent={SupportAgentIcon}
                                          value={service}
                                          label={t("user.service")}
                                          onChange={(e) => setService(e.target.value)}
                                        >
                                          {GlobalData.user.services.map((val, index) => {
                                            return (
                                              <MenuItem key={index} value={val}>{t("user.services." + val)}</MenuItem>
                                            )
                                          })}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                </div>
                              }



                              <hr />


                              <div className="tab-pane" id="basic-info">

                                <h4 className="card-title">{t("user.loginDetails")}</h4>
                                <p className="card-title-desc"></p>


                                <div className="row mb-3">
                                  <div className="col-4">
                                    <TextField value={email} error={errors.mail} fullWidth variant="outlined" type="text" label={t("user.mail")} onChange={(e) => setemail(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <EmailIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>
                                  <div className="col-4">
                                    <TextField value={password} error={errors.password} fullWidth variant="outlined" type="password" label={t("user.password")} onChange={(e) => setpassword(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <LockIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>
                                  <div className="col-4">
                                    <TextField value={confirmPassword} error={errors.confirmPassword} fullWidth variant="outlined" type="password" label={t("user.confirmPassword")} onChange={(e) => setconfirmPassword(e.target.value)}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <LockIcon />
                                          </InputAdornment>
                                        )
                                      }} />
                                  </div>

                                </div>
                              </div>


                            </div>




                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
            }
          </Box>




          <Button
            disabled={isLoading}
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#ca8d42",
              "&:hover": {
                backgroundColor: "#b07b39"
              },
            }}
            className="mb-3"
            onClick={onSubmit}
          >
            {isLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              signupStep < 2 ? t("next") : t("signup")
            )}
          </Button>



          {signupStep > 0 &&
            <Button
              disabled={isLoading}
              fullWidth
              variant="outlined"
              color="primary"
              className="mb-3"
              onClick={onPrevious}
            >
              {t("back")}
            </Button>
          }
        </div>
      </div>
    </Container>

  )
}

export default SignUp2